import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
var GlobalStateContext = React.createContext([{}, function () {}]);

var GlobalStateProvider = function GlobalStateProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      globalState = _useState2[0],
      setGlobalState = _useState2[1];

  return /*#__PURE__*/React.createElement(GlobalStateContext.Provider, {
    value: {
      globalState: globalState,
      setGlobalState: setGlobalState
    }
  }, children);
};

var isValidPaymentData = function isValidPaymentData(globalState) {
  return (globalState === null || globalState === void 0 ? void 0 : globalState.isValidCard) == true && (globalState === null || globalState === void 0 ? void 0 : globalState.isValidCvv) == true && (globalState === null || globalState === void 0 ? void 0 : globalState.isValidExpiry) == true;
};

export { GlobalStateContext, GlobalStateProvider, isValidPaymentData };